import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import { map } from 'rxjs/operators';
import constants from '../constants';
import { MEMBER } from '../models/member';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(
    private afs: AngularFirestore,
  ) { }

  getByDocId = (docId: string) => {
    return this.afs
      .collection(constants.FB_ADMINS)
      .doc(docId)
      .get();
  }

  getAdmins({
    roles = [],
  }: { roles?: Array<string> }) {
    return this.afs.collection(constants.FB_ADMINS, (ref: any) => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if (roles) { query = query.where('roles', 'array-contains-any', roles); }
      query = query.orderBy('firstNameToSearch', 'asc');
      return query;
    }).snapshotChanges().pipe(
      map((actions: any) => {
        return actions.map((a: any) => {
          const admin = a.payload.doc.data() as MEMBER;
          admin.docId = a.payload.doc.id;
          return admin;
        });
      })
    );
  }

  doSave = async (docId: string, changes: any, fUser: firebase.User) => {
    if (docId === 'new') {
      const collection = this.afs.collection(constants.FB_ADMINS);
      changes.createdBy = { uid: fUser.uid, email: fUser.email };
      changes.dateCreated = firebase.firestore.FieldValue.serverTimestamp();
      const res = await collection.add(Object.assign({}, changes));
      docId = res.id;
    } else {
      const collection = this.afs.collection(constants.FB_ADMINS);
      changes.lastUpdatedBy = { uid: fUser.uid, email: fUser.email };
      changes.lastUpdated = firebase.firestore.FieldValue.serverTimestamp();
      await collection.doc(docId).update(Object.assign({}, changes));
    }
  }

  checkEmailExists = async (email: string): Promise<any> => {
    try {
      if (!email) { return true; }
      const validEmail = firebase.functions().httpsCallable('authGroup-onEmailExists');
      const response: any = await validEmail({ email });

      return response.data;
    } catch (error) {
      console.log('ERROR >> ', error);
      return {};
    }
  }

  checkPhoneNumberExists = async (phoneNumber: string): Promise<any> => {
    try {
      if (!phoneNumber) { return true; }
      const callable = firebase.functions().httpsCallable('authGroup-onPhoneExists');
      const response: any = await callable({ phoneNumber });

      return response.data;
    } catch (error) {
      console.log('ERROR >> ', error);
      return {};
    }
  }
}
